import { Cluster } from '@cast/types';
import { CloudAssetCluster } from '@cast/types-inventory';

import { toDiscoveredCluster } from './toDiscoveredCluster';

/**
 * OneClick org list: CAST clusters (including NOT_FOUND so they can be removed)
 * plus inventory-only assets whose name is not already present in CAST.
 */
export const mergeClustersWithInventory = (
  clusters: Cluster[] | undefined,
  assetListClusters: CloudAssetCluster[] | undefined
): Cluster[] => {
  const castClusters = clusters ?? [];
  const castNames = new Set(
    castClusters.map((cluster) => cluster.name).filter(Boolean)
  );

  const pureDiscovered = (assetListClusters ?? [])
    .filter((asset) => asset.name && !castNames.has(asset.name))
    .map(toDiscoveredCluster)
    .filter((cluster): cluster is Cluster => cluster != null);

  return [...pureDiscovered, ...castClusters];
};
